import React from "react";
import "./PreviousCards.css";

function ArrowIcon() {
  return (
    <svg
      className="arrowSvg-ptcs"
      viewBox="0 0 24 24"
      width="18"
      height="18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M7 17L17 7"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
      />
      <path
        d="M10 7h7v7"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function Icon({ type }) {
  // mini icônes line-style proches de l'image
  if (type === "graphic")
    return (
      <svg className="cardIcon-ptcs" viewBox="0 0 24 24" fill="none">
        <path
          d="M4 15l7-7 6 6"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14 8l2-2 4 4-2 2"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6 19h12"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
        />
      </svg>
    );

  if (type === "uiux")
    return (
      <svg className="cardIcon-ptcs" viewBox="0 0 24 24" fill="none">
        <path
          d="M4 6h16v10H4z"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinejoin="round"
        />
        <path
          d="M9 20h6"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
        />
        <path
          d="M12 16v4"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
        />
        <path
          d="M14 8l4-2-2 4"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );

  if (type === "dev")
    return (
      <svg className="cardIcon-ptcs" viewBox="0 0 24 24" fill="none">
        <path
          d="M4 6h16v12H4z"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinejoin="round"
        />
        <path
          d="M8 10l-2 2 2 2"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16 10l2 2-2 2"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11 15l2-6"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
        />
      </svg>
    );

  // marketing
  return (
    <svg className="cardIcon-ptcs" viewBox="0 0 24 24" fill="none">
      <path
        d="M4 11v2a2 2 0 0 0 2 2h1l3 3v-8l-3 3H6a2 2 0 0 1-2-2Z"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
      <path
        d="M10 10l8-4v12l-8-4"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
      <path
        d="M19.5 9.5a3 3 0 0 1 0 5"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  );
}

export default function PreviousCards() {
  const cards = [
    {
      id: 1,
      icon: "graphic",
      title: "Gestion de Stock",
      desc:
        "Gardez le contrôle total de vos stocks avec une solution simple, fiable et pensée pour améliorer votre efficacité.",
    },
    {
      id: 2,
      icon: "uiux",
      title: "Site Web et Applications mobiles",
      desc:
        "Développez votre présence digitale grâce à des sites web et applications mobiles sur mesure, pensés pour engager vos utilisateurs.",
    },
    {
      id: 3,
      icon: "dev",
      title: "Paiements en ligne",
      desc:
        "Offrez à vos clients des paiements en ligne rapides, simples et sécurisés pour faciliter leurs achats et renforcer la confiance.",
    },
    {
      id: 4,
      icon: "mkt",
      title: "Catalogue de Produits",
      desc:
        "Présentez vos produits de manière professionnelle grâce à un catalogue structuré, intuitif et pensé pour capter l’attention de vos clients.",
    },
  ];

  return (
    <section className="wrap-ptcs">
      <div className="panel-ptcs">
        {/* Header row */}
        <div className="top-ptcs">
          <div className="topLeft-ptcs">
            <span className="tag-ptcs">Nos Services</span>
            <h2 className="heading-ptcs">
              Faites grandir votre marque <br />
              Déclenchez votre succès
            </h2>
          </div>

          <div className="topRight-ptcs">
            <p className="lead-ptcs">
              Quand la vision rencontre l’identité, nous accompagnons les marques vers un avenir ambitieux.
            </p>
            <a className="connectBtn-ptcs" href="https://wa.me/+22893410827" style={{ textDecoration : 'none'}}>
              Contactez-nous
            </a>
          </div>
        </div>

        {/* Cards grid */}
        <div className="grid-ptcs">
          {cards.map((c) => (
            <article key={c.id} className="card-ptcs">
              <div className="cardTop-ptcs">
                <Icon type={c.icon} />
                <button className="goBtn-ptcs" aria-label={`Open ${c.title}`}>
                  <ArrowIcon />
                </button>
              </div>

              <h3 className="cardTitle-ptcs">{c.title}</h3>
              <p className="cardDesc-ptcs">{c.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
